import { Box, Image } from "@chakra-ui/react";
import React from "react";
import { useIntl } from "react-intl";
import { affirmationBg } from "src/assets/icons";
import Breadcrumb from "src/components/Breadcrumb/Breadcrumb";

const BaseView: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { formatMessage, locale } = useIntl();

  return (
    <Box>
      <Breadcrumb />
      {children}
      <Image
        src={affirmationBg}
        position="absolute"
        bottom={0}
        right={0}
        zIndex={-1}
        transform={locale === "en" ? "scaleX(-1)" : undefined}
      />
    </Box>
  );
};

export default BaseView;
